<template>
    <button @click="$router.back()" class="btn btn-light fw-semibold px-4 py-2">Back</button>
</template>

<script lang="ts" setup>

</script>